import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Candidates from './components/Candidates';
import Companies from './components/Companies';
import CompanyDetail from './components/CompanyDetail';
import Opportunities from './components/Opportunities';
import IntegrationOpportunities from './components/IntegrationOpportunities';
import OpportunityEditPage from './components/OpportunityEditPage';
import OpportunityDetailsPage from './components/OpportunityDetailsPage';
import Recruiters from './components/Recruiters';
import Applies from './components/Applies';
import CompanySubscriptions from './components/CompanySubscriptions';
import CompanyCreditsList from './components/CompanyCreditsList';
import OnboardingAb from './components/OnboardingAb';
import Nps from './components/Nps';
import Layout from './components/Layout';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { colors } from './styles/colors';
import { fonts } from './styles/fonts';
import './App.css'; 

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return null;
  }

  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
};

function App() {
  // Aplicar estilos globais do Trampos
  React.useEffect(() => {
    document.body.style.fontFamily = fonts.body;
    document.body.style.backgroundColor = colors.background;
    document.body.style.color = colors.text;
    
    // Adicionar fontes do Google
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Taviraj:wght@100;200;300;400;500;600;700;800;900&family=Roboto+Slab:wght@300;400;500;600;700&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }, []);

  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Navigate to="/companies" />} />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/candidates" element={
              <ProtectedRoute>
                <Layout>
                  <Candidates />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/companies" element={
              <ProtectedRoute>
                <Layout>
                  <Companies />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/companies/:companyId/details" element={
              <ProtectedRoute>
                <Layout>
                  <CompanyDetail />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/opportunities" element={
              <ProtectedRoute>
                <Layout>
                  <Opportunities />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/opportunities/:opportunityId/edit" element={
              <ProtectedRoute>
                <Layout>
                  <OpportunityEditPage />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/opportunities/:opportunityId/details" element={
              <ProtectedRoute>
                <Layout>
                  <OpportunityDetailsPage />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/integration-opportunities" element={
              <ProtectedRoute>
                <Layout>
                  <IntegrationOpportunities />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/integration-opportunities/:opportunityId/edit" element={
              <ProtectedRoute>
                <Layout>
                  <OpportunityEditPage />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/integration-opportunities/:opportunityId/details" element={
              <ProtectedRoute>
                <Layout>
                  <OpportunityDetailsPage />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/recruiters" element={
              <ProtectedRoute>
                <Layout>
                  <Recruiters />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/applies" element={
              <ProtectedRoute>
                <Layout>
                  <Applies />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/company-subscriptions" element={
              <ProtectedRoute>
                <Layout>
                  <CompanySubscriptions />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/company-credits" element={
              <ProtectedRoute>
                <Layout>
                  <CompanyCreditsList />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/onboarding-ab" element={
              <ProtectedRoute>
                <Layout>
                  <OnboardingAb />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/nps" element={
              <ProtectedRoute>
                <Layout>
                  <Nps />
                </Layout>
              </ProtectedRoute>
            } />
          </Routes>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            toastStyle={{
              fontFamily: fonts.body,
              fontSize: fonts.sizes.sm
            }}
          />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
